<h1 *ngIf="!iframeMode">Velkommen til ShareIt!</h1>
<p>
    {{guideText}}
</p>
<div class="row">
    <div class="col-md-12">
        <a [routerLink]="['/login']">Log ind</a>
    </div>
    <div class="col-md-12">
        <a [routerLink]="['/signup']">Opret bruger</a>
    </div>

</div>